import React, { useEffect, useState } from 'react';

function BitcoinConverter({ value }) {
  const [btcRate, setBtcRate] = useState(null); // BTC/USD

  // Fetch live BTC rate every 20 seconds
  useEffect(() => {
    const fetchRate = async () => {
      try {
        const res = await fetch(
          'https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=usd'
        );
        const data = await res.json();
        setBtcRate(data.bitcoin.usd);
      } catch (err) {
        console.error('Failed to fetch BTC rate:', err);
      }
    };

    fetchRate();
    const interval = setInterval(fetchRate, 20000);
    return () => clearInterval(interval);
  }, []);

  const convertToBitcoin = (amountInDollars) => {
    const number = typeof amountInDollars === 'string'
      ? parseFloat(amountInDollars.replace(/,/g, ''))
      : amountInDollars;

    if (isNaN(number) || !btcRate) {
      return '...'; // Waiting for data or invalid input
    }

    const bitcoinAmount = number / btcRate;
    return bitcoinAmount.toFixed(8);
  };

  const bitcoinValue = convertToBitcoin(value);

  return (
    <>
      {btcRate ? (
        <>
          {bitcoinValue}  
          {/* @ ${btcRate.toLocaleString()} per BTC */}
        </>
      ) : (
        <>Loading live rate...</>
      )}
    </>
  );
}

export default BitcoinConverter;
